import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <div style="height: 74.5vh;">
      <p>
        Pagina non trovata
      </p>
    </div>
  `,
  styles: [],
})
export class NotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
